/*ěščřžýáíéúů*/
(function ($) {
	const $title   = $('.category-page__sidebar-title');
	const $catList = $('.category-page__cat-list');

	// Toggle subcategory list on mobile when sidebar title is clicked
	$title.on('click', function () {
		if ($catList.is(':hidden')) {
			$catList.slideDown(400);
			$title.addClass('category-page__sidebar-title--open');
		} else {
			$catList.slideUp(400);
			$title.removeClass('category-page__sidebar-title--open');
		}
	});
})(jQuery);
